import { render, staticRenderFns } from "./PowerStationDetailFour.vue?vue&type=template&id=24015623&"
import script from "./PowerStationDetailFour.vue?vue&type=script&lang=js&"
export * from "./PowerStationDetailFour.vue?vue&type=script&lang=js&"
import style0 from "./PowerStationDetailFour.vue?vue&type=style&index=0&id=24015623&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports